//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// eslint-disable-next-line object-curly-newline
import { ref, watch, nextTick } from '@vue/composition-api'

export default {
  setup() {
    const items = ['Gaming', 'Programming', 'Vue', 'Vuetify']
    const selectedList = ref(['Vuetify'])
    const search = ref(null)

    watch(selectedList, value => {
      if (value.length > 5) {
        nextTick(() => selectedList.value.pop())
      }
    })

    return { items, selectedList, search }
  },
}
